import {yupResolver} from '@hookform/resolvers/yup';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {FormProvider, SubmitHandler, useForm} from 'react-hook-form';
import {ScrollView, Text, View} from 'react-native';
import {Card, Divider} from 'react-native-paper';
import {useSelector} from 'react-redux';
import * as yup from 'yup';
import {buildLogoUrl, ShowToast} from '../Common/common';
import BTButton from '../Components/BTButton';
import BTCheckbox from '../Components/BTCheckbox';
import BTComboBox from '../Components/BTComboBox';
import {Col, Row} from '../Components/BTGrid';
import {TextInput} from '../Components/BTTextInput';
import {useGetModesQuery} from '../redux/services/amodeApi';
import {useInsertFOECheckinAdvMutation} from '../redux/services/foecheckinadvApi';
import {
  useGetFOECheckinsQuery,
  useGetFOEOccRoomsQuery,
} from '../redux/services/foecheckinApi';
import {RootState} from '../redux/store';
import styles from '../styles/FOStyles';
import AdvanceReceipt from './Print/AdvanceReceipt';
import {useGetFORoomssQuery} from '../redux/services/foroomsApi';
import {useGetFOSettingByIdQuery} from '../redux/services/foasettingApi';

import { tp } from '../utils/translateText';
const validationSchema = yup.object({
  ca_checkin: yup.number().min(1, 'Folio is required').typeError('Required'),
  ca_amt: yup.number().required('Amount is required').typeError('Required'),
  ca_mode: yup.number().min(1, 'Mode is required').typeError('Required'),
});


const AdvanceForm = ({navigation, route}: UniversalProps) => {
  const gdata = useSelector((state: RootState) => state.gdata);
  const cid = gdata.company;
  const {data: checkinData} = useGetFOECheckinsQuery(cid);
  const {data: occData} = useGetFOEOccRoomsQuery({cid: cid, coid: 0});
  const {data: modeData} = useGetModesQuery(cid);
  const {data: roomData} = useGetFORoomssQuery(cid);
  const {data: foSetting} = useGetFOSettingByIdQuery(cid);
  const [insertAdvance] = useInsertFOECheckinAdvMutation();
  const [isSaving, setIsSaving] = useState(false);

  const initialValues = {
    ca_id: 0,
    ca_company: cid,
    ca_date: moment(gdata.today).format('YYYY/MM/DD HH:mm:ss'),
    ca_no: '',
    ca_checkin: 0,
    ca_mode: Number(gdata.defmode),
    ca_amt: 0,
    ca_refno: '',
    ca_refdt: moment().format('YYYY/MM/DD HH:mm:ss'),
    ca_refbank: '',
    ca_remarks: '',
    ca_flag: '1',
    ca_uid: gdata.user,
    ca_cdt: moment().format('YYYY/MM/DD HH:mm:ss'),
    ca_muid: gdata.user,
    ca_mdt: moment().format('YYYY/MM/DD HH:mm:ss'),
  };

  const methods = useForm<any>({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const {handleSubmit, reset} = methods;

  const checkins = checkinData?.map(item => ({
    label: `${item.ci_no} - ${item.ab_name}`,
    id: item.ci_id,
  }));

  const modes = modeData
    ?.filter(v => v.md_flag !== '0')
    ?.map(item => ({
      label: item.md_name,
      id: item.md_id,
    }));

  useEffect(() => {
    if (route.params?.room) {
      const selectedRoom = occData?.find(
        (v: any) => v.rm_id === Number(route.params.room),
      );
      methods.reset({
        ...initialValues,
        ca_checkin: selectedRoom ? selectedRoom.ci_id : 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route.params?.room, occData]);

  const onSubmit: SubmitHandler<any> = async values => {
    if (foSetting?.se_manualreceipt === 1 && Number(values.ca_amt) > 0) {
      const hasRef = String(values.ca_remarks || values.ca_refno || '').trim().length > 0;
      if (!hasRef) {
        ShowToast('Manual Receipt No / Reference is required', 'danger');
        return;
      }
    }

    setIsSaving(true);
    try {
      const result: any = await insertAdvance(values).unwrap();
      ShowToast('Advance Saved Successfully', 'success');
      reset();

      // Print Receipt
      const dat = {
        data: {
          ...result,
          ca_remarks: values.ca_remarks,
          ci_remarks: values.ca_remarks,
          ci_arrvial: checkinData?.find(v => v.ci_id === values.ca_checkin)
            ?.ci_arrvial,
          ci_depature: checkinData?.find(v => v.ci_id === values.ca_checkin)
            ?.ci_depature,
          ci_days: checkinData?.find(v => v.ci_id === values.ca_checkin)?.ci_days,
          ab_mobile: checkinData?.find(v => v.ci_id === values.ca_checkin)
            ?.ab_mobile,
          ab_name: checkinData?.find(v => v.ci_id === values.ca_checkin)?.ab_name,
        },
      };

      const dat1 = {
        printheader: true,
        cm_name: gdata.companyname,
        cm_addr1: gdata.addr1 + ', ',
        cm_addr2: gdata.addr2,
        cm_addr3: gdata.city + ' - ' + gdata.pincode,
        cm_logo: buildLogoUrl(gdata.company, gdata.logo),
        cm_room: roomData || [],
        ca_mode: modes?.find((v: any) => v.id === values.ca_mode)?.label,
      };

      await AdvanceReceipt(dat, dat1);
      navigation.navigate('StatusScreen');
    } catch (error: any) {
      ShowToast(error?.data?.message || 'Failed to save advance', 'danger');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <View style={{ flex: 1, backgroundColor: '#f5f5f5' }}>
      <FormProvider {...methods}>
        <ScrollView
          contentContainerStyle={{
            padding: 8,
            paddingBottom: 80,
            flexGrow: 1,
            backgroundColor: '#f5f5f5',
          }}
          keyboardShouldPersistTaps="handled"
        >
        <Card style={styles.card}>
          <Card.Title title="Checkin Advance" titleStyle={styles.cardTitle} />
          <Card.Content>
            <Row>
              <Col>
                <TextInput name="ca_date" label="Date" editable={false} />
              </Col>
              <Col>
                <TextInput name="ca_no" label="Receipt #" editable={false} />
              </Col>
            </Row>
            <Row>
              <Col>
                <BTComboBox
                  name="ca_checkin"
                  label="Folio"
                  data={checkins}
                  placeholder={tp("Select Folio")}
                  editable={false}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <BTComboBox
                  name="ca_mode"
                  label="Mode"
                  data={modes}
                  placeholder={tp("Select Mode")}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInput
                  name="ca_amt"
                  label="Amount"
                  keyboardType="numeric"
                  textAlign="right"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInput name="ca_refno" label="Ref No" />
              </Col>
              <Col>
                <TextInput name="ca_refbank" label="Ref Bank" />
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInput
                  name="ca_remarks"
                  label={foSetting?.se_manualreceipt === 1 ? 'Remarks / Manual Ref *' : 'Remarks / Manual Ref'}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <BTCheckbox name="ca_flag" label="Active" />
              </Col>
            </Row>
            <Divider />
            <Row>
              <Col>
                <BTButton
                  title="Save"
                  onPress={handleSubmit(onSubmit)}
                  onLongPress={() => {}}
                  color="#146C94"
                  disabled={isSaving}
                />
              </Col>
              <Col>
                <BTButton
                  title="Cancel"
                  onPress={() => {
                    reset();
                    navigation.navigate('StatusScreen');
                  }}
                  onLongPress={() => {}}
                  color="#146C94"
                  disabled={isSaving}
                />
              </Col>
            </Row>
          </Card.Content>
        </Card>
      </ScrollView>
    </FormProvider>
  </View>
);
};

export default AdvanceForm;

